import React from 'react';
import classnames from 'classnames';
import { ButtonDropdown, ButtonDropdownProps } from 'framework/form';
import { useFilterContext } from '../../../FilterContext';

interface DefaultFilterInputLayoutProps extends ButtonDropdownProps {
  onResetFilterCallback?: () => void;
}

const DefaultFilterInputLayout = ({
  children,
  className,
  source = '',
  onResetFilterCallback,
  displayedValue,
  ...props
}: DefaultFilterInputLayoutProps) => {
  const { clearAndApplyFilter, isStatic } = useFilterContext();

  const resetFilter = () => {
    if (onResetFilterCallback) {
      onResetFilterCallback();
    } else {
      clearAndApplyFilter(source);
    }
  };

  return (
    <ButtonDropdown
      {...props}
      displayedValue={displayedValue}
      className={classnames('filter-input', className)}
      onRemoveCallback={!isStatic || displayedValue ? resetFilter : null}
      shouldCloseMenuOnReset={isStatic}
      data-testid="mock-button-dropdown"
    >
      {children}
    </ButtonDropdown>
  );
};

export default DefaultFilterInputLayout;
